import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlayIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7 6.99793L7 13.0021L12.009 10L7 6.99793ZM6.04183 4.09196C5.56253 3.8047 5 4.22527 5 4.87088V15.1291C5 15.7747 5.56254 16.1953 6.04183 15.908L14.5998 10.7789C15.1334 10.4591 15.1334 9.54089 14.5998 9.22108L6.04183 4.09196Z",
		fill: "#005AA0"
	})]
});
const ForwardRef = forwardRef(SvgPlayIcon);
export { ForwardRef as ReactComponent };
